import { Component } from 'react'
import { connect } from 'react-redux'
import { setReplayUrl } from '../../../redux/actions'

function preventTouch(e) {
  event.preventDefault()
}

@connect(null, { setReplayUrl })
export default class ReplayFrame extends Component {
  componentDidMount() {
    window.addEventListener('touchstart', preventTouch)
  }
  componentWillUnmount() {
    window.removeEventListener('touchstart', preventTouch)
  }

  closeReplay = () => {
    this.props.setReplayUrl('')
  }

  render() {
    const { dimensions, replayUrl } = this.props
    const { height } = dimensions

    return (
    <div className="replay-frame" style={{ height }}>
      <iframe src={replayUrl} {...{ height }} scrolling="auto" />
      <div className="replay-close fa fa-times-circle" onClick={this.closeReplay}/>
    </div>
    )
  }
}